<template>
  <div class="aboutus">
    <menuBox :step="2"></menuBox>
    <div class="aboutus-box">
      <div class="title">
        <p>เกี่ยวกับเรา</p>
        <span>เดินหน้าสร้างอนาคตที่ดีกว่าและมุ่งมั่นที่จะเป็นแบบอย่างในอุตสาหกรรม</span>
      </div>
    </div>
    <div class="people-box">
      <div class="people-content">
        <div class="left">
          <p><b>สิบปี</b> ประสบการณ์ในอุตสาหกรรมที่สั่งสมมา</p>
          <span>ด้วยประสบการณ์ในอุตสาหกรรมหลายปี ORACLE LIFE ได้สร้างตำแหน่งทางการตลาดที่มั่นคงในด้านผลิตภัณฑ์ทางการเกษตร
            สิ่งทอ เครื่องใช้ในบ้าน และเครื่องปรุงรส
            บริษัทประสบความสำเร็จในการสร้างระบบการผลิตที่มีประสิทธิภาพและยั่งยืนผ่านนวัตกรรมทางเทคโนโลยีอย่างต่อเนื่องและกระบวนการบริหารจัดการที่เหมาะสมที่สุด
            ในเวลาเดียวกัน
            ความเข้าใจอย่างลึกซึ้งเกี่ยวกับการเปลี่ยนแปลงของตลาดและความเข้าใจอย่างลึกซึ้งในความต้องการของลูกค้า
            ช่วยให้บริษัทสามารถเป็นผู้นำในตลาดที่มีความหลากหลายได้เสมอ</span>
        </div>
        <div class="right">
          <div class="item">
            <img src="../assets/people1.png" alt="">
            <p>บริการตลอด 24 ชั่วโมงทุกวัน</p>
          </div>
          <div class="item">
            <img src="../assets/people2.png" alt="">
            <p>ราคาไม่แพง</p>
          </div>
          <div class="item">
            <img src="../assets/people3.png" alt="">
            <p>แฮนดี้แมนมืออาชีพ</p>
          </div>
        </div>
      </div>
    </div>
    <div class="customers-box">
      <div class="customers-content">
        <div class="item">
          <img src="../assets/customers1.png" alt="">
          <p>500+</p>
          <span>พนักงานขาย</span>
        </div>
        <div class="item">
          <img src="../assets/customers2.png" alt="">
          <p>40+</p>
          <span>สาขาออฟไลน์</span>
        </div>
        <div class="item">
          <img src="../assets/customers3.png" alt="">
          <p>10+</p>
          <span>เกียรติยศทางสังคม</span>
        </div>
        <div class="item">
          <img src="../assets/customers4.png" alt="">
          <p>100+</p>
          <span>เหรียญ</span>
        </div>
      </div>
    </div>
    <div class="services-box">
      <div class="title">ออราเคิล ไลฟ์</div>
      <div class="text">การทำงานเป็นทีม</div>
      <div class="content">
        <div class="item">
          <div class="imgBox">
            <img src="../assets/member1.png" class="services" alt="">
          </div>
          <div class="titleBox">
            <p>ทีมที่หลากหลาย</p>
            <span>รวบรวมผู้มีความสามารถที่มีภูมิหลังและทักษะทางวิชาชีพที่แตกต่างกันเพื่อส่งเสริมความหลากหลายของการคิดเชิงนวัตกรรมและแนวทางแก้ไข</span>
          </div>
        </div>
        <div class="item">
          <div class="imgBox">
            <img src="../assets/member2.png" class="services" alt="">

          </div>
          <div class="titleBox">
            <p>การสื่อสารที่มีประสิทธิภาพ</p>
            <span>สร้างช่องทางการสื่อสารแบบเปิดเพื่อให้มั่นใจว่าข้อมูลไหลเวียนได้อย่างราบรื่น และเสริมสร้างการประสานงานและความเข้าใจภายในทีม</span>
          </div>
        </div>
        <div class="item">
          <div class="imgBox">
            <img src="../assets/member3.png" class="services" alt="">
          </div>
          <div class="titleBox">
            <p>เป้าหมายที่ใช้ร่วมกัน</p>
            <span>สมาชิกในทีมแบ่งปันเป้าหมายและวิสัยทัศน์ที่ชัดเจน ทำงานร่วมกันอย่างใกล้ชิด และทำงานร่วมกันเพื่อบรรลุความสำเร็จในระยะยาวของบริษัท</span>
          </div>
        </div>
      </div>
    </div>
    <div class="aboutus-fotter">
      <div class="title">
        <p>ทำงานร่วมกันเพื่อสร้างอนาคตที่สดใส</p>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    aboutUs() {
      this.$router.push({ path: "aboutUs" });
    },
  },
};
</script>
<style lang="less" scoped>
.aboutus-box {
  background-image: url(../assets/about1.png);
  width: 100%;
  height: 320px;
  background-size: 100% 100%;
  text-align: center;
  overflow: hidden;

  .title {
    padding-top: 127px;

    p {
      margin-bottom: 6px;
      font-size: 40px;
      font-family: Arial, Arial;
      font-weight: normal;
      color: #FFFFFF;
    }

    span {
      font-size: 14px;
      font-family: ArialMT;
      color: #FFFFFF;
    }
  }
}

.people-box {
  background-image: url(../assets/people.png);
  width: 100%;
  height: 500px;
  background-size: 100% 100%;
  overflow: hidden;

  .people-content {
    display: flex;
    align-items: center;
    padding: 138px 360px;

    .left {
      b {
        color: #F56604;
      }

      p {
        width: 500px;
        margin-bottom: 40px;
        font-size: 40px;
        font-weight: 700;
        font-family: Arial, Arial;
        font-weight: normal;
        color: #333;
      }

      span {
        display: block;
        width: 520px;
        font-size: 14px;
        font-family: ArialMT;
        color: #333333;
      }
    }

    .right {
      margin-left: 80px;

      .item {
        display: flex;
        align-items: center;
        margin-bottom: 40px;

        img {
          margin-right: 24px;
          width: 48px;
          height: 48px;
        }

        p {
          font-size: 24px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #333333;
        }
      }

      .item:nth-child(3) {
        margin-bottom: 0;
      }
    }
  }
}

.customers-box {
  background-image: url(../assets/customers.png);
  width: 100%;
  height: 400px;
  background-size: 100% 100%;
  text-align: center;
  padding: 132px 400px;
  box-sizing: border-box;
  overflow: hidden;

  .customers-content {
    display: flex;
    justify-content: space-between;

    .item {
      img {
        margin-bottom: 16px;
        width: 48px;
        height: 48px;
      }

      p {
        margin-bottom: 8px;
        font-size: 40px;
        font-family: Arial, Arial;
        font-weight: normal;
        color: #FFFFFF;
      }

      span {
        font-size: 14px;
        font-family: ArialMT;
        color: #FFFFFF;
      }
    }
  }
}

.aboutus-fotter {
  background-image: url(../assets/aboutusFotter.png);
  width: 100%;
  height: 480px;
  background-size: 100% 100%;
  text-align: center;
  overflow: hidden;

  .title {
    margin: 0 auto;
    width: 748px;
    padding-top: 196px;

    p {
      font-size: 40px;
      font-family: Arial, Arial;
      font-weight: normal;
      color: #FFFFFF;
    }
  }
}

.services-box {
  padding: 120px 360px;

  .title {
    text-align: center;
    margin-bottom: 10px;
    font-size: 14px;
    font-family: ArialMT;
    color: #F56604;
  }

  .text {
    text-align: center;
    font-size: 40px;
    font-family: Arial, Arial;
    font-weight: normal;
    color: #333333;
  }

  .content {
    margin-top: 56px;
    display: flex;

    .item {
      margin-right: 45px;

      .imgBox {
        position: relative;
        width: 370px;
        height: 248px;

        .services {
          width: 370px;
          height: 248px;
        }
      }

      .titleBox {
        width: 370px;
        height: 220px;
        padding: 40px 32px;
        box-sizing: border-box;
        text-align: center;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.13);

        p {
          margin-bottom: 10px;
          font-size: 22px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #333333;
        }

        span {
          font-size: 16px;
          font-family: ArialMT;
          color: #333333;
          line-height: 24px;
        }
      }
    }

    .item:nth-child(3) {
      margin-right: 0;
    }
  }
}</style>
